import React from 'react';
import Fade from 'react-reveal/Fade';
import { useStaticQuery, graphql } from 'gatsby';
import { Icon } from 'react-icons-kit';
import { apple } from 'react-icons-kit/fa/apple';
import { android } from 'react-icons-kit/fa/android';
import { openModal, closeModal } from '@redq/reuse-modal';
import Text from 'reusecore/src/elements/Text';
import Image from 'reusecore/src/elements/Image';
import Button from 'reusecore/src/elements/Button';
import Heading from 'reusecore/src/elements/Heading';
import Rating from 'common/src/components/Rating';
import Container from 'common/src/components/UI/Container';
import BannerWrapper, {
  BannerContent,
  RatingInfo,
  BannerImage,
  ButtonGroup,
  VideoGroup,
  VideoWrapper,
  CustomerWrapper,
  ImageWrapper,
} from './banner.style';

import microsoft from 'common/src/assets/image/appModern/envato-icon.png';
import bannerImg from 'common/src/assets/image/appModern/banner2.png';
import videoBanner1 from 'common/src/assets/image/appModern/video-1.png';
import videoBanner2 from 'common/src/assets/image/appModern/video-2.png';
import circleBorder from 'common/src/assets/image/appModern/shape.svg';

// close button for modal
const CloseModalButton = () => (
  <Button
    className="modalCloseBtn"
    variant="fab"
    onClick={() => closeModal()}
    icon={<i className="flaticon-plus-symbol" />}
  />
);

const ModalContent = (video) => (
  <VideoWrapper>
    <iframe
      title="Video"
      src={video}
      frameBorder="0"
    />
  </VideoWrapper>
);

const Banner = () => {
  const data = useStaticQuery(graphql`
    query {
      appModernJson {
        client {
          id
          title
          image {
            publicURL
          }
        }
      }
    }
  `);
  const { client } = data.appModernJson;
  // modal handler
  const handleVideoModal = (video) => {
    openModal({
      config: {
        className: 'video-modal',
        disableDragging: true,
        default: {
          width: 'auto',
          height: 'auto',
          x: 0,
          y: 0,
        },
      },
      component: () => ModalContent(video),
      componentProps: {},
      closeComponent: CloseModalButton,
      closeOnClickOutside: true,
    });
  };
  return (
    <BannerWrapper id="home">
      <Container>
        <BannerContent>
        
          <Fade up delay={5}>
            <Heading
              as="h1"
              content="Elegant Flutter App"
            />
          </Fade>

          <Fade up delay={100}>
            <Text
              content="Full E-commerce mobile app, full integration with WooCommerce, Shopify, Magento, Opencart, and Prestashop, running on both iOS and Android."
            />
          </Fade>

          <Fade up>
            <RatingInfo>
              <Rating rating={200} />
              5.0 of 5 By <img src={microsoft} height={18} alt="Microsoft" />
            </RatingInfo>
          </Fade>

          <Fade up delay={300}>
            <ButtonGroup>

              <a target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/us/app/mstore-flutter/id1469772800">
                <Button
                  className="text"
                  variant="textButton"
                  icon={<Icon icon={apple} />}
                  iconPosition="left"
                  title="Appstore"
                />
              </a>

              <a target="_blank" rel="noopener noreferrer" href="	https://play.google.com/store/apps/details?id=com.inspireui.fluxstore">
                <Button
                  className="text"
                  variant="textButton"
                  icon={<Icon icon={android} />}
                  iconPosition="left"
                  title="Google Play"
                />
              </a>

            </ButtonGroup>
          </Fade>
          <VideoGroup>
            <img
              width={220}
              src={videoBanner1}
              onClick={() => handleVideoModal("https://www.youtube.com/embed/sYnHhnS5WnQ?autoplay=1")}
              alt="Microsoft"
            />
            <img
              width={220}
              src={videoBanner2}
              onClick={() => handleVideoModal("https://www.youtube.com/embed/eYLCq5tD9BI?autoplay=1")}
              alt="Microsoft"
            />
          </VideoGroup>
        </BannerContent>
        <BannerImage>
          <Fade up delay={100}>
            <Image src={bannerImg} height={744} alt="Banner" />
          </Fade>
        </BannerImage>
      </Container>
      <CustomerWrapper>
        <Text content="Compatible with:" />
        <ImageWrapper>
          {client.map(item => (
            <Image
              height={32}
              key={`client-key${item.id}`}
              src={item.image.publicURL}
              alt={item.title}
            />
          ))}
        </ImageWrapper>
      </CustomerWrapper>
      <img
        className="bannerBottomShape"
        src={circleBorder}
        alt="Bottom Circle"
      />
    </BannerWrapper>
  );
};

export default Banner;
